import type { Fig, GoalDto } from "@nabla/api";
import { designCopy } from "../design/copy.ts";
import { budget, moneyOf } from "../design/format/money.ts";
import { formatFrequency, formatNumber, formatPercent, formatRatio } from "../design/format/numbers.ts";
import { capitalized } from "../design/format/text.ts";
import { wordsCopy as t } from "./copy.ts";
import type { Words } from "./session.ts";

export function figureLabel(metric: Fig["metric"], words: Words): string {
  if (metric === "pedidos") return capitalized(words.resultado.varios);
  if (metric === "vendas") return capitalized(words.vendas);
  if (metric === "custo-por-pedido") return t.custoPor(words.resultado.um);
  if (metric === "custo-por-pedido-sem-imposto") return t.custoPorSemImposto(words.resultado.um);
  return t.rotulo[metric];
}

export function figureNumber(fig: Fig): string | undefined {
  if (fig.value === null) return undefined;
  if (fig.unit === "minor") return moneyOf(fig.metric)({ minor: fig.value, currency: fig.currency });
  if (fig.unit === "count") return formatNumber(fig.value);
  if (fig.unit === "frequency") return formatFrequency(fig.value);
  return inPercent(fig.metric) ? formatPercent(fig.value) : formatRatio(fig.value);
}

const shares = new Set<Fig["metric"]>(["ctr-link", "investido-sobre-vendas-loja", "carrinho-sobre-sessoes", "pedido-sobre-checkout"]);
export const inPercent = (metric: Fig["metric"]): boolean => shares.has(metric);

export function bounded(fig: Fig, text: string): string {
  return fig.bound === "minimo" ? `${designCopy.peloMenos} ${text}` : text;
}

export function inline(fig: Fig): string {
  const number = figureNumber(fig);
  return number === undefined ? "—" : bounded(fig, number);
}

export function goalNumber(goal: GoalDto): string {
  const ratio = goal.metric === "retorno" || goal.metric === "roas-meta";
  return ratio ? formatRatio(goal.target) : budget({ minor: goal.target, currency: goal.currency });
}

export const shownFigure = (fig: Fig | undefined): string => (fig === undefined ? "—" : inline(fig));
